let waitingForSecond = false;
let firstKey = '';
let resetTimeout;

const SHORTCUTS = {
    'g+d': { path: '#/', label: 'Дашборд' },
    'g+a': { path: '#/accounts', label: 'Аккаунты' },
    'g+b': { path: '#/billing', label: 'Биллинг' },
    'g+s': { path: '#/stats', label: 'Статистика' },
    'g+r': { path: '#/roles', label: 'Роли' },
    'g+t': { path: '#/system', label: 'Система' },
    'g+u': { path: '#/users', label: 'Пользователи' },
    'g+c': { path: '#/calls', label: 'Звонки' },
    'g+p': { path: '#/partners', label: 'Партнёры' },
    'g+m': { path: '#/map', label: 'Карта' },
};

export function initKeyboardShortcuts() {
    document.addEventListener('keydown', (e) => {
        // Ignore if typing in input/textarea/select
        const tag = e.target.tagName;
        if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
        if (e.metaKey || e.ctrlKey || e.altKey) return;

        if (e.key === '?') {
            e.preventDefault();
            showHelp();
            return;
        }

        if (waitingForSecond) {
            const combo = firstKey + '+' + e.key.toLowerCase();
            waitingForSecond = false;
            clearTimeout(resetTimeout);

            if (SHORTCUTS[combo]) {
                e.preventDefault();
                window.location.hash = SHORTCUTS[combo].path;
            }
            return;
        }

        if (e.key === 'g') {
            waitingForSecond = true;
            firstKey = 'g';
            resetTimeout = setTimeout(() => { waitingForSecond = false; }, 1000);
        }
    });
}

function showHelp() {
    // Check if already open
    if (document.getElementById('shortcutsHelp')) return;

    const overlay = document.createElement('div');
    overlay.className = 'modal-overlay';
    overlay.id = 'shortcutsHelp';
    overlay.innerHTML = `
        <div class="modal" style="max-width:400px">
            <div class="modal-header">
                <h3 class="modal-title">Горячие клавиши</h3>
                <button class="modal-close" id="shortcutsClose">&times;</button>
            </div>
            <div class="modal-body">
                <div class="shortcuts-list">
                    <div class="shortcut-row"><kbd>Cmd/Ctrl+K</kbd><span>Поиск</span></div>
                    <div class="shortcut-row"><kbd>?</kbd><span>Показать справку</span></div>
                    <div class="shortcut-row"><kbd>G → D</kbd><span>Дашборд</span></div>
                    <div class="shortcut-row"><kbd>G → A</kbd><span>Аккаунты</span></div>
                    <div class="shortcut-row"><kbd>G → B</kbd><span>Биллинг</span></div>
                    <div class="shortcut-row"><kbd>G → S</kbd><span>Статистика</span></div>
                    <div class="shortcut-row"><kbd>G → R</kbd><span>Роли</span></div>
                    <div class="shortcut-row"><kbd>G → T</kbd><span>Система</span></div>
                    <div class="shortcut-row"><kbd>G → U</kbd><span>Пользователи</span></div>
                    <div class="shortcut-row"><kbd>G → C</kbd><span>Звонки</span></div>
                    <div class="shortcut-row"><kbd>G → P</kbd><span>Партнёры</span></div>
                    <div class="shortcut-row"><kbd>G → M</kbd><span>Карта</span></div>
                </div>
            </div>
        </div>`;

    document.body.appendChild(overlay);

    const close = () => overlay.remove();
    overlay.querySelector('#shortcutsClose').addEventListener('click', close);
    overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function handler(e) {
        if (e.key === 'Escape') { close(); document.removeEventListener('keydown', handler); }
    });
}
